module.exports = __webpack_public_path__ + "static/media/pdf.a0640edc.svg";